import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { formatDate } from '@projects/shared/src/app/utils';
import { Subject, Subscription, debounceTime, firstValueFrom } from 'rxjs';
import { CheckPermission } from '@projects/shared/src/app/utils/helper';
import { AgentCallEvaluationService } from '../../features/insight/agent-calls-evaluation/agent-call-evaluation.service';
import { AuthenticationService } from '@app/core';
import { CxTableService } from '../../modules/cx-datagrid/services/cx-table.service';
import { environment } from '@env/environment';
import { NgScrollbar } from 'ngx-scrollbar';
import { CallRecordingService } from '@projects/admin/src/app/services/call-recording.service';

@Component({
  selector: 'app-audio-visualizer',
  templateUrl: './audio-visualizer.component.html',
  styleUrls: ['./audio-visualizer.component.scss'],
})
export class AudioVisualizerComponent implements OnInit {
  @Output() loaded = new EventEmitter<void>();
  @Output() close = new EventEmitter();
  @ViewChild('visualizer', { static: false }) visualizer!: ElementRef;
  @ViewChild('audioPlayer', { static: false }) audioPlayer!: ElementRef;
  @ViewChild('audioPlayer2', { static: false }) audioPlayer2!: ElementRef;

  @ViewChild('seekBar', { static: false }) seekBar!: ElementRef;
  @ViewChild(NgScrollbar) scrollbarRef!: NgScrollbar;

  @Input() draggable: boolean = true;
  @Input() isVoiceMail: boolean = false;
  @Input() isSaleCall: boolean = false;

  formatDate = formatDate;
  checkPermission = CheckPermission;
  showAudioPlayer: boolean = false;
  isDraggable: boolean = false;
  isTranscriptEnabled: boolean = true;


  private audioSubscription!: Subscription;
  private downloadClick$ = new Subject<void>();
  private lastScrollPosition = 0;

  viewDisposition: boolean = false;
  dragPosition = { x: 0, y: 0 };
  right = "0";
  top = "0";
  isFloaterCollapsed = true;
  isMiniFloater = false;
  isAudioLoaded: boolean = false;

  seekBarValue = 0;
  volume = 100;
  muted: boolean = false;

  startTime: number = 0;
  pausedAt: number = 0;
  isPlaying: boolean = false;
  hasStarted: boolean = false;
  audioContext!: AudioContext;
  duration: any;
  customerName: string = '';
  callSID: string = '';
  activeSpeed: number = 1;
  seekPercentage: number = 0;
  isAgentTrackMuted: boolean = false;
  isCustomerTrackMuted: boolean = false;
  isLoading: boolean = true;
  isDownloading: boolean = false;
  showDuration: boolean = true;
  allowDownload: boolean = true;
  fileName: string = '';
  currentPlaybackTime: number = 0;
  leftGainNode!: GainNode;
  rightGainNode!: GainNode;
  analyserLeft!: AnalyserNode;
  analyserRight!: AnalyserNode;
  _url: string = '';
  visualizerLeftData: any = {};
  visualizerRightData: any = {};
  hoverTime: number = 0; // Stores the hovered time in seconds
  tooltipPositionX: number = 0; // X position of the tooltip
  tooltipPositionY: number = 0; // Y position of the tooltip
  hoverTimeVisible: boolean = false; // Controls visibility of the tooltip
  transcriptData: any[] = [];
  currentSegmentIndex: number | null = null;
  constructor(
    public authService: AuthenticationService,
    public cxtableService: CxTableService,
    public callRecordingService: CallRecordingService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    public service: AgentCallEvaluationService
  ) {
    this.downloadClick$.pipe(
      debounceTime(300)
    ).subscribe(() => this.handleDownload());
  }

  ngOnInit(): void {
    this.audioSubscription = this.service.isDraggable$.subscribe(
      (isDraggable: any) => {
        if (isDraggable) {
          this.isFloaterCollapsed = false;
          this.isMiniFloater = true;
          this.isDraggable = isDraggable;
          this.dragPosition = { x: 0, y: 0 };
          this.right = "450px";
          this.top = "20px";
        }
        else {
          this.calculatePosition();
          this.isMiniFloater = false;
          this.isDraggable = false;
          this.isFloaterCollapsed = true;
        }
      }
    );
    this.audioSubscription = this.service.audioPlayerState$.subscribe(
      (newState: any) => {
        this.allowDownload = CheckPermission('quality_evaluation_list_allow_download_sup', '', this.authService);
        this.isVoiceMail = newState.route === "voicemail" ? true : false;
        if (this.showAudioPlayer) {
          this.showAudioPlayer = false;
          this.reset();
          this.cd.detectChanges();
          this.calculatePosition();
          setTimeout(() => {
            this.loadNewState(newState);
          }, 500);
        } else
          this.loadNewState(newState);
      }
    );
  }

  calculatePosition() {
    // const screenWidth = window.innerWidth;
    // const screenHeight = window.innerHeight;
    this.right = "25px";
    this.top = "245px";
  }

  loadNewState(newState: any): void {
    this.showAudioPlayer = newState.show;
    this.duration = newState.details?.Duration;
    this.customerName = `${newState.details?.CustomerFirstName || ''} ${newState.details?.CustomerLastName || ''}`;
    this.callSID = newState.details?.CallSid;
    this.isSaleCall = newState.details?.IsSale;
    if (this.showAudioPlayer)
      this.loadTracks();
    else
      this.reset();
  }

  async loadTracks() {
    if (this.isSaleCall && !this.isVoiceMail)
      this.fetchTranscript();
    const recording_token = await firstValueFrom(this.authService.getCurrentUserToken());
    const actionName = this.isVoiceMail ? 'voicemail' : 'calls';
    // const url = `https://next.flecx.io/voice/api/recordings/calls/stream?CallSid=CA725e359f7ab9c697c9d31190bb043e67&recording_token=eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI2U19LdU0wbUNwd1RQSFFISmsxSW5yekh1dW1Ua0ZpTkdHR2duN3Zpdm44In0.eyJleHAiOjE3MzIwNTQzMjUsImlhdCI6MTczMjAxMTEyNSwiYXV0aF90aW1lIjoxNzMyMDExMTI1LCJqdGkiOiIwNjYzMmVmNi1lY2M5LTRlNTMtYmY3OC03NTIyMmJlNjk2MDciLCJpc3MiOiJodHRwczovL2lkZW50aXR5LmZsZWN4LmlvL3JlYWxtcy9mbGVjeCIsImF1ZCI6WyJhbmd1bGFyLWNsaWVudCIsImFjY291bnQiXSwic3ViIjoiMjAxN2MwMWItYWU2Ny00YWEzLWIyZWItOTJmYWQ2NTA0MjA4IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiYW5ndWxhci1jbGllbnQiLCJzaWQiOiI5NzFlM2Y5MS1lZWI0LTQ0NWUtODFjOS0yMGEzMDc4YjBjM2UiLCJhbGxvd2VkLW9yaWdpbnMiOlsiKiJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsidXNlciJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoib3BlbmlkIGVtYWlsIGFwaSBwcm9maWxlIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJVc2VySWQiOiI2NTU1MTI5ZTA2YWQyODZkY2QzZDlkN2YiLCJuYW1lIjoiU3VwIFR3byIsIkNsaWVudElkIjoiNjU1MzljMWZjYjI2NTMyZjIzYWFjMmJmIiwicHJlZmVycmVkX3VzZXJuYW1lIjoic3VwMkBmbGVjeC5pbyIsImdpdmVuX25hbWUiOiJTdXAiLCJmYW1pbHlfbmFtZSI6IlR3byIsImVtYWlsIjoic3VwMkBmbGVjeC5pbyJ9.h7jOeDcoIOsyixoWs3f-Jf4EZ0GzQllrtkZ47UCY9m_g6WtoGlYGr5dam7OCcM-MGPdc6rVrl_9bLPsgJrZtnigDMI_ebOOCJK1KIPW1sss4ror075JysGAl9lFjJZksH0DDSaGAlSI1UMo6IgWaicMrgIDmLWwa5hVBcBRmXaePc51SFBKMVhE5UgkRWxvSv2WObFOAYYpEGdFSiR1kuQUg24T7hHcZxeuNWIzYgY-PrI-VSRzCq9FxTtWUZ7g97AW4uToUk_H8PKyhUH9LJ3HD064XR1_6D2aQJncn-IUBHeAHZ6lOaN6sUkZJqBvEokHp5qFCQ2LqgUE_f_KcGg`;
    const url = `${environment.telephony.url}/api/recordings/${actionName}/stream?CallSid=${this.callSID}&recording_token=${recording_token}`;
    (await fetch(url, { method: 'POST' })).text().then((res: string) => {
      this._url = url;
      this.loadVisualizerPlaceholder(this._url);
      this.loadVisualizer(this._url);
    }).catch((error: any) => {
      console.error('Error loading audio:', error);
      this.ngZone.run(() => {
        this.isLoading = false;
        this.cd.detectChanges();
      });
    });
  }

  draw(placeholder = false) {
    let canvas = this.visualizer?.nativeElement;
    let audioElement = this.audioPlayer?.nativeElement;
    let canvasCtx = canvas.getContext('2d');

    const leftBars: any = this.visualizerLeftData;
    const rightBars: any = this.visualizerRightData;
    const barSize = 8.5;
    const agentTopDistance = 50;
    const totalDuration = this.getTotalDuration();
    const minutes = Math.floor(totalDuration / 60) + 1;
    const audioSize = minutes; // 44.50 minutes
    let containerSize = ((audioSize - 0.85) * 61) * barSize;
    if (containerSize < 555) {
      containerSize = 555;
    }

    canvas.style.width = containerSize + 'px';
    canvas.style.width = containerSize + 'px';
    canvas.setAttribute('width', containerSize);
    canvasCtx.clearRect(0, 0, canvas.width, canvas.height);


    canvasCtx.fillStyle = "#aaa";
    canvasCtx.fillRect(0, agentTopDistance, containerSize, 1);

    let index = 1;
    let pindex = 0;
    for (let i in leftBars) {
      canvasCtx.beginPath();
      canvasCtx.lineCap = "round";
      canvasCtx.lineWidth = barSize;
      canvasCtx.moveTo((index * barSize) + 0.1, agentTopDistance);
      canvasCtx.lineTo((index * barSize) + 0.1, agentTopDistance - leftBars[i].val);
      const filled = leftBars[i].filled;
      if (leftBars[i].val > 0) {
        canvasCtx.strokeStyle = !filled ? "#4c675c" : "#2dce89";
        canvasCtx.stroke();
      }

      canvasCtx.beginPath();
      canvasCtx.lineCap = "round";
      canvasCtx.lineWidth = barSize;
      canvasCtx.moveTo((index * barSize) + 0.1, agentTopDistance + 2)
      canvasCtx.lineTo((index * barSize) + 0.1, rightBars[i].val + agentTopDistance + 2);
      if (rightBars[i].val > 0) {
        canvasCtx.strokeStyle =  !filled ? "#24535c" : "#11cdef";;
        canvasCtx.stroke();
      }
      if (pindex === 0) {
        canvasCtx.font = "9px Gilroy-Regular";
        canvasCtx.fillText(i, ((index - 0.9) * (barSize)), (agentTopDistance * 2) + 20);
      }
      pindex++
      index++;

      if (pindex > 4) {
        pindex = 0;
      }
    }
  }

  init() {
    let canvas = this.visualizer?.nativeElement;
    let audioElement = this.audioPlayer?.nativeElement;
    const leftBars: any = {};
    const rightBars: any = {};
    const barSize = 7;
    const totalDuration = this.getTotalDuration();
    const minutes = Math.floor(totalDuration / 60);
    let hours = Math.floor(minutes / 60);
    const seconds = Math.floor(totalDuration % 60);
    const audioSize = minutes; // 44.50 minutes
    let containerSize = ((audioSize - 0.85) * 61) * barSize;
    if (containerSize < 555) {
      containerSize = 555;
    }
    canvas.style.width = containerSize + 'px';
    canvas.setAttribute('width', containerSize);

    Array(Math.floor(audioSize)).fill(0).forEach((minutes, mindex) => {
      Array(60).fill(0).forEach((minutes, sindex) => {
        const key = `${this.getTwoDigitNumber(hours)}:${this.getTwoDigitNumber(mindex)}:${this.getTwoDigitNumber(sindex)}`;
        if (!this.visualizerLeftData[key]?.val) {
          leftBars[key] = { val: 0, w: 10 };
          rightBars[key] = { val: 0, w: 10 };
        } else {
          leftBars[key] = this.visualizerLeftData[key];
          rightBars[key] = this.visualizerRightData[key];
        }
      })
    })

    Array(Math.floor(seconds) + 1).fill(0).forEach((minutes, mindex) => {
      const key = `${this.getTwoDigitNumber(hours)}:${this.getTwoDigitNumber(audioSize)}:${this.getTwoDigitNumber(mindex)}`;
      if (!this.visualizerLeftData[key]?.val) {
        leftBars[key] = { val: 0, w: 10 };
        rightBars[key] = { val: 0, w: 10 };
      } else {
        leftBars[key] = this.visualizerLeftData[key];
        rightBars[key] = this.visualizerLeftData[key];
      }
    })

    this.visualizerLeftData = leftBars;
    this.visualizerRightData = rightBars;
  }

  loadVisualizer(sourceUrl: string) {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    let audioElement = this.audioPlayer?.nativeElement;
    let canvas = this.visualizer?.nativeElement;

    const analyserLeft = audioContext.createAnalyser();
    const analyserRight = audioContext.createAnalyser();

    analyserLeft.fftSize = 2048; // FFT size (adjustable)
    analyserRight.fftSize = 2048; // FFT size (adjustable)

    const bufferLeftLength = analyserLeft.frequencyBinCount;
    const bufferRightLength = analyserRight.frequencyBinCount;

    const dataArrayLeft = new Uint8Array(bufferLeftLength);
    const dataArrayRight = new Uint8Array(bufferRightLength);

    this.visualizerLeftData = {};
    this.visualizerRightData = {};

    // Create a stereo splitter and merger
    const splitter = audioContext.createChannelSplitter(2);
    const merger = audioContext.createChannelMerger(2);

    // Create gain nodes for each channel (left and right)
    this.leftGainNode = audioContext.createGain();
    this.rightGainNode = audioContext.createGain();

    // Connect the audio element to the AudioContext
    const source = audioContext.createMediaElementSource(audioElement);

    // Split channels: left to leftGainNode and right to rightGainNode
    source.connect(splitter);
    splitter.connect(this.leftGainNode, 0); // Left channel
    splitter.connect(this.rightGainNode, 1); // Right channel

    // Connect gain nodes to analyzers and to the merger
    this.leftGainNode.connect(analyserLeft);
    this.rightGainNode.connect(analyserRight);

    // Merge the channels back for stereo output
    analyserLeft.connect(merger, 0, 1); // Connect left analyzer to left output
    analyserRight.connect(merger, 0, 0); // Connect right analyzer to right output

    // Connect the merger to the destination (speakers)
    merger.connect(audioContext.destination);


    const analyzeAudio = (_canvas: any) => {
      const analyzeInterval = setInterval(() => {
        const currentTime = audioElement.currentTime;
        let minutes = Math.floor(currentTime / 60);
        let hours = Math.floor(minutes / 60);
        const seconds = Math.floor(currentTime % 60);

        analyserLeft.getByteFrequencyData(dataArrayLeft);
        analyserRight.getByteFrequencyData(dataArrayRight);

        const countLeft = analyzeFrequencies(dataArrayLeft, 'left');
        const countRight = analyzeFrequencies(dataArrayRight, 'right');

        const leftKey = `${this.getTwoDigitNumber(hours)}:${this.getTwoDigitNumber(minutes)}:${this.getTwoDigitNumber(seconds)}`;
        const rightKey = `${this.getTwoDigitNumber(hours)}:${this.getTwoDigitNumber(minutes)}:${this.getTwoDigitNumber(seconds)}`;

        if (!this.visualizerLeftData[leftKey].val) {
          this.visualizerLeftData[leftKey] = { val: countLeft, w: 10, filled: true };
        } else {
          if (countLeft > this.visualizerLeftData[leftKey].val) {
            this.visualizerLeftData[leftKey].val = countLeft;
            this.visualizerLeftData[leftKey].filled = true;
          } else {
            this.visualizerLeftData[leftKey].filled = true;
          }
        }

        if (!this.visualizerRightData[rightKey].val) {
          this.visualizerRightData[rightKey] = { val: countRight, w: 10, filled: true };
        } else {
          if (countRight > this.visualizerRightData[rightKey].val) {
            this.visualizerRightData[rightKey].val = countRight;
            this.visualizerRightData[rightKey].filled = true;
          } else {
            this.visualizerRightData[rightKey].filled = true;
          } 
        }

        this.draw();
      }, 100);

      audioElement.addEventListener('pause', () => {
        clearInterval(analyzeInterval);
      });

      this.seekBar?.nativeElement.addEventListener('input', (event: any) => {
        const seekTime = this.seekPercentage * this.getTotalDuration();
        this.audioPlayer.nativeElement.currentTime = seekTime;
        // this.scrollbarRef.nativeElement.addEventListener('timeupdate', this.updateScrollPosition.bind(this));
      });

      this.audioPlayer.nativeElement.addEventListener('timeupdate', () => {
        const __width = Number(_canvas.style.width.replace('px', ''));
        if (this.audioPlayer?.nativeElement?.currentTime) {
          this.seekBarValue = (this.audioPlayer.nativeElement.currentTime / this.getTotalDuration()) * 100;
          this.scrollbarRef.scrollTo({
            left: __width * ((this.seekBarValue - (this.seekBarValue * 0.091)) / 100), // - (0.1 / 100),
            duration: 0,
          })
          this.syncTranscriptWithAudio();
        }
      });

    }

    function analyzeFrequencies(data: any, side = 'left') {
      let leftCount = 0;
      let rightCount = 0;
      const threshold = 10;
      const scalingFactor = 50 / 100;

      for (let i = 0; i < data.length; i++) {
        if (i % 2 === 0) {
          if (data[i] > threshold) {
            leftCount++;
          }
        }
        else {
          if (data[i] > threshold) {
            rightCount++;
          }
        }
      }
      if (side === 'left') {
        return leftCount * scalingFactor;
      }

      return rightCount * scalingFactor;
    }
    
    audioElement.src = sourceUrl;
    audioElement.load();

    audioElement.addEventListener('loadeddata', () => {
      this.audioPlayer2.nativeElement.preservesPitch = true;
      this.audioPlayer2.nativeElement.playbackRate = 6;
      this.audioPlayer2?.nativeElement.play();
      audioElement.play()
        .then(() => {
          console.log(new Date().toLocaleString() + " | Audio playback started successfully.");
          analyzeAudio(canvas);
          this.init();
          this.isAudioLoaded = true;
        })
        .catch((error: any) => {
          console.error("Error starting playback:", error);
        });
    });
    
    audioElement.addEventListener('play', () => {
      // Start analyzing when audio plays
      analyzeAudio(canvas);
      this.init();
    });

  }

  loadVisualizerPlaceholder(sourceUrl: string) {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    let audioElement = this.audioPlayer2?.nativeElement;
    let canvas = this.visualizer?.nativeElement;

    const analyserLeft = audioContext.createAnalyser();
    const analyserRight = audioContext.createAnalyser();
    analyserLeft.fftSize = 2048;
    analyserRight.fftSize = 2048;

    const bufferLeftLength = analyserLeft.frequencyBinCount;
    const bufferRightLength = analyserRight.frequencyBinCount;

    const dataArrayLeft = new Uint8Array(bufferLeftLength);
    const dataArrayRight = new Uint8Array(bufferRightLength);

    this.visualizerLeftData = {};
    this.visualizerRightData = {};

    const source = audioContext.createMediaElementSource(audioElement);
    // Create a stereo splitter and merger
    const splitter = audioContext.createChannelSplitter(2);

    const outputGainNode = audioContext.createGain();

    source.connect(splitter);
    splitter.connect(analyserLeft, 0); // Left channel
    splitter.connect(analyserRight, 1); // Right channel

    // Connect splitter channels to output GainNode for playback
    splitter.connect(outputGainNode, 0);
    splitter.connect(outputGainNode, 1);

    // Connect GainNode to the speakers
    outputGainNode.connect(audioContext.destination);

    // leftGainNode.gain.value = 0;
    outputGainNode.gain.value = 0;


    const analyzeAudio = (_canvas: any) => {
      const analyzeInterval = setInterval(() => {
        const currentTime = audioElement.currentTime;
        let minutes = Math.floor(currentTime / 60);
        let hours = Math.floor(minutes / 60);
        const seconds = Math.floor(currentTime % 60);

        analyserLeft.getByteFrequencyData(dataArrayLeft);
        analyserRight.getByteFrequencyData(dataArrayRight);

        const countLeft = analyzeFrequencies(dataArrayLeft, 'left');
        const countRight = analyzeFrequencies(dataArrayRight, 'right');

        const leftKey = `${this.getTwoDigitNumber(hours)}:${this.getTwoDigitNumber(minutes)}:${this.getTwoDigitNumber(seconds)}`;
        const rightKey = `${this.getTwoDigitNumber(hours)}:${this.getTwoDigitNumber(minutes)}:${this.getTwoDigitNumber(seconds)}`;

        if (!this.visualizerLeftData[leftKey].val) {
          this.visualizerLeftData[leftKey] = { val: countLeft, w: 10, filled: false };
        } else {
          if (countLeft > this.visualizerLeftData[leftKey].val) {
            this.visualizerLeftData[leftKey].val = countLeft;
          }
        }

        if (!this.visualizerRightData[rightKey].val) {
          this.visualizerRightData[rightKey] = { val: countRight, w: 10, filled: false };
        } else {
          if (countRight > this.visualizerRightData[rightKey].val) {
            this.visualizerRightData[rightKey].val = countRight;
          }
        }

        this.draw(true);
      }, 100);

      audioElement.addEventListener('pause', () => {
        clearInterval(analyzeInterval);
      });
    }

    function analyzeFrequencies(data: any, side = 'left') {
      let leftCount = 0;
      let rightCount = 0;
      const threshold = 10;
      const scalingFactor = 50 / 100;

      for (let i = 0; i < data.length; i++) {
        if (i % 2 === 0) {
          if (data[i] > threshold) {
            leftCount++;
          }
        }
        else {
          if (data[i] > threshold) {
            rightCount++;
          }
        }
      }
      if (side === 'left') {
        return leftCount * scalingFactor;
      }

      return rightCount * scalingFactor;
    }
    
    audioElement.src = sourceUrl;
    audioElement.load();

    audioElement.addEventListener('loadeddata', () => {
      audioElement.play()
        .then(() => {
          console.log(new Date().toLocaleString() + " | Audio playback started successfully.");
          this.isAudioLoaded = true;
          analyzeAudio(canvas);
          this.init();
        })
        .catch((error: any) => {
          console.error("Error starting playback:", error);
        });
    });
    
    audioElement.addEventListener('play', () => {
      // Start analyzing when audio plays
      analyzeAudio(canvas);
      this.init();
    });

  }
 

  updateScrollPosition(): void {
    const totalDuration = this.getTotalDuration();
    const currentTime = this.getCurrentTime();

    if (totalDuration > 0) {
      const scrollWidth = 555; // Width of canvas
      const scrollPosition = (currentTime / totalDuration) * scrollWidth;

      if (Math.abs(scrollPosition - this.lastScrollPosition) > 1) {
        this.lastScrollPosition = scrollPosition;
        this.scrollbarRef.scrollTo({
          left: scrollPosition,
          duration: 50,
        })
      }
    }
  }

  getTwoDigitNumber(number = 0) {
    let strNumber = '';
    if (number < 10) {
      strNumber = '0' + number;
    } else {
      strNumber = String(number);
    }

    return strNumber;
  }


  getCurrentTime(): number {
    return this.audioPlayer?.nativeElement.currentTime || 0;
  }

  getTotalDuration(): number {
    let duration = 0;
    if (this.isAudioLoaded) {
      const audioDuration = this.audioPlayer?.nativeElement?.duration;
      duration = isFinite(audioDuration) && !isNaN(audioDuration) ? audioDuration : this.duration;
    }
    return duration;
  }

  playSingleTrack(trackId: number): void {
    if (trackId === 0) {
      // Mute/unmute Agent Track (Left channel)
      if (this.isCustomerTrackMuted) {
        this.rightGainNode.gain.value = 1;
        this.isCustomerTrackMuted = false;
      }
      this.leftGainNode.gain.value = this.isAgentTrackMuted ? 1 : 0;
      this.isAgentTrackMuted = !this.isAgentTrackMuted;
    } else {
      // Mute/unmute Customer Track (Right channel)
      if (this.isAgentTrackMuted) {
        this.leftGainNode.gain.value = 1;
        this.isAgentTrackMuted = false;
      }
      this.rightGainNode.gain.value = this.isCustomerTrackMuted ? 1 : 0;
      this.isCustomerTrackMuted = !this.isCustomerTrackMuted;

    }
  }

  canPlay(): boolean {
    return Number(this.audioPlayer?.nativeElement?.duration) > 0;
  }

  playAllTracks(): void {
    const totalDuration = this.audioPlayer.nativeElement.duration;
    if (Number.isNaN(totalDuration) || totalDuration < 0) {
      return;
    }

    if (Math.ceil(this.getCurrentTime()) >= this.duration) {
      this.audioPlayer.nativeElement.currentTime = 0;
      this.seekBarValue = 0;
    }
    this.showDuration = false;
    this.hasStarted = true;
    this.audioPlayer?.nativeElement.play();

    this.isPlaying = true;
  }

  pause(): void {
    this.audioPlayer?.nativeElement.pause();
    this.isPlaying = false;
  }

  isPaused(): boolean {
    return this.audioPlayer?.nativeElement.paused;
  }

  forward(): void {
    if (this.getCurrentTime() > this.duration)
      return;
    this.audioPlayer.nativeElement.currentTime = this.audioPlayer.nativeElement.currentTime + 10;
    this.seekBarValue = (this.audioPlayer.nativeElement.currentTime / this.getTotalDuration()) * 100;
  }

  backward(): void {
    if (this.getCurrentTime() < 0)
      return;
    this.audioPlayer.nativeElement.currentTime = this.audioPlayer.nativeElement.currentTime - 10;
    this.seekBarValue = (this.audioPlayer.nativeElement.currentTime / this.getTotalDuration()) * 100;
  }

  seekAudio(event: any): void {
    // Calculate the target seek time based on seek bar percentage
    const seekTime = this.seekPercentage * this.getTotalDuration();
    this.seekBarValue = event.target.value;

    // Set loading state to show buffering
    this.isAudioLoaded = false;

    // Add a small delay to ensure the audio element has time to handle seek processing
    setTimeout(() => {
        this.audioPlayer.nativeElement.currentTime = seekTime;

        // Store current time for comparison
        const currentTimeBeforeSeek = this.audioPlayer.nativeElement.currentTime;

        // Check for currentTime changes after seeking
        const checkCurrentTimeChange = setInterval(() => {
            const currentTimeAfterSeek = this.audioPlayer.nativeElement.currentTime;

            // If currentTime has changed significantly, hide loading
            if (Math.abs(currentTimeAfterSeek - currentTimeBeforeSeek) > 0.1) {
                this.isAudioLoaded = true;
                clearInterval(checkCurrentTimeChange);
            }
        }, 100); // Check every 100 milliseconds

        // Set a timeout to force-hide loading after 3 seconds, even if buffering is delayed
        setTimeout(() => {
            this.isAudioLoaded = true;
            clearInterval(checkCurrentTimeChange);
        }, 10000);
    }, 200); // 200ms delay to stabilize currentTime setting
}


  showHoverTime(event: MouseEvent): void {
    const seekBar = event.target as HTMLInputElement;
    const seekBarRect = seekBar.getBoundingClientRect();
    const offsetX = event.clientX - seekBarRect.left;
    const totalWidth = seekBarRect.width;
    const hoverPercentage = offsetX / totalWidth;
    this.seekPercentage = hoverPercentage;
    const hoverTimeInSeconds = hoverPercentage * this.getTotalDuration();
    this.hoverTime = formatDate(hoverTimeInSeconds);

    this.tooltipPositionX = this.isMiniFloater ? offsetX + 100 : offsetX;
    this.tooltipPositionY = !this.isFloaterCollapsed ? 40 : this.isMiniFloater ? 10 : 190;
    this.hoverTimeVisible = true;
  }

  hideHoverTime(): void {
    this.hoverTimeVisible = false;
  }


  setVolume(event: any): void {
    this.muted = this.volume === 0 && true;
    this.leftGainNode.gain.value = (event.target.value / 100) * 1;
    this.rightGainNode.gain.value = (event.target.value / 100) * 1;
    this.volume = event.target.value;
  }

  toggleMute(): void {
    this.muted = !this.muted;
    if (this.muted)
      this.volume = 0;
    else
      this.volume = 100;

    this.leftGainNode.gain.value = (this.volume / 100) * 1;
    this.rightGainNode.gain.value = (this.volume / 100) * 1;
  }

  setPlaybackRate(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.activeSpeed = parseFloat(target.value);
    this.audioPlayer.nativeElement.preservesPitch = true;
    this.audioPlayer.nativeElement.playbackRate = this.activeSpeed;
  }

  downloadAudio(): void {
    this.downloadClick$.next();
  }

  private async handleDownload(): Promise<void> {
    try {
      this.isDownloading = true;
      const recording_token = await firstValueFrom(this.authService.getCurrentUserToken());
      const actionName = this.isVoiceMail ? 'voicemail' : 'calls';
      const url = `${environment.telephony.url}/api/recordings/${actionName}/stream_download?CallSid=${this.callSID}&recording_token=${recording_token}`;

      const link = document.createElement('a');
      link.href = url;
      link.download = `${this.callSID}.wav`;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();

    } catch (error) {
      console.error('Error downloading or processing the track:', error);
    } finally {
      this.isDownloading = false;
    }
  }

  onClose(e: MouseEvent) {
    this.reset();
    this.service.setShowRecordingDetailsSidebar(false, null, 'recording');
    e.preventDefault();
    this.close.emit('');
  }

  reset() {
    this.pausedAt = 0;
    this.duration = 0;
    this.isPlaying = false;
    this.hasStarted = false;
    this.showAudioPlayer = false;
    this.isAudioLoaded = false;
    this.isAgentTrackMuted = false;
    this.isCustomerTrackMuted = false;
    this.seekBarValue = 0;
    this.activeSpeed = 1;
    this.volume = 100;
    this.muted = false;
    this._url = '';
    if (this.audioPlayer)
      this.audioPlayer.nativeElement = null;
  }

  resetPosition() {
    this.dragPosition = { x: 0, y: 0 };
  }

  toggleFloaterCollapse() {
    this.isFloaterCollapsed = !this.isFloaterCollapsed;
  }

  toggleMiniFloater() {
    this.isMiniFloater = !this.isMiniFloater;
  }

  onDragEnded(event: any): void {
    this.dragPosition = event.source.getFreeDragPosition();
  }

  fetchTranscript() {
    this.callRecordingService.getCallTranscript(this.callSID).subscribe({
      next: (response: any) => {
        this.transcriptData = response;
      },
      error: (error: any) => {
      },
      complete: () => {
      },
    });
  }

  syncTranscriptWithAudio() {
    const currentTime = this.audioPlayer.nativeElement.currentTime;
    this.currentSegmentIndex = this.transcriptData.findIndex(segment =>
      currentTime >= segment.start && currentTime < segment.end
    );
  }

  toggleTranscript() {
    this.isTranscriptEnabled = !this.isTranscriptEnabled;
  }

  onTranscriptClosed(): void {
    this.isTranscriptEnabled = false;  
  }

}
